import { c as _c } from "react/compiler-runtime";
export const HyperEVMLogoCircle = t0 => {
  const $ = _c(16);
  let className;
  let rest;
  let square;
  let t1;
  if ($[0] !== t0) {
    ({
      className,
      size: t1,
      square,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = rest;
    $[3] = square;
    $[4] = t1;
  } else {
    className = $[1];
    rest = $[2];
    square = $[3];
    t1 = $[4];
  }
  const size = t1 === undefined ? 24 : t1;
  let t2;
  if ($[5] !== size) {
    t2 = {
      width: size,
      height: size
    };
    $[5] = size;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <path d="M0 22C0 9.84974 9.84974 0 22 0V0C34.1503 0 44 9.84974 44 22V22C44 34.1503 34.1503 44 22 44V44C9.84974 44 0 34.1503 0 22V22Z" fill="#072723" />;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const t4 = square ? "M0 0 H44 V44 H0 Z" : "M22 0.5C33.8741 0.5 43.5 10.1259 43.5 22C43.5 33.8741 33.8741 43.5 22 43.5C10.1259 43.5 0.5 33.8741 0.5 22C0.5 10.1259 10.1259 0.5 22 0.5Z";
  let t5;
  if ($[8] !== t4) {
    t5 = <path d={t4} stroke="white" strokeOpacity="0.08" />;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <path d="M36.8397 21.8616C36.8397 31.6737 30.835 34.8222 27.6712 32.0187C25.067 29.7328 24.2922 24.9023 20.3751 24.4063C15.4035 23.7809 14.973 30.4014 11.7016 30.4014C7.89216 30.4014 7.1604 24.8592 7.1604 22.0126C7.1604 19.1013 7.97825 15.1333 11.2281 15.1333C15.0161 15.1333 15.2313 20.8049 19.9662 20.503C24.6796 20.1796 24.7657 14.2707 27.822 11.7476C30.4906 9.56947 36.8397 11.9201 36.8397 21.8616Z" fill="#97FCE4" />;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== className || $[12] !== rest || $[13] !== t2 || $[14] !== t5) {
    t7 = <svg className={className} style={t2} viewBox="0 0 44 44" xmlns="http://www.w3.org/2000/svg" {...rest}>{t3}{t5}{t6}</svg>;
    $[11] = className;
    $[12] = rest;
    $[13] = t2;
    $[14] = t5;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  return t7;
};
export const HyperEVMLogoCircleMonochrome = t0 => {
  const $ = _c(15);
  let className;
  let rest;
  let t1;
  let t2;
  let t3;
  if ($[0] !== t0) {
    ({
      className,
      size: t1,
      fill: t2,
      fillAttribute: t3,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = rest;
    $[3] = t1;
    $[4] = t2;
    $[5] = t3;
  } else {
    className = $[1];
    rest = $[2];
    t1 = $[3];
    t2 = $[4];
    t3 = $[5];
  }
  const size = t1 === undefined ? 24 : t1;
  t2 === undefined ? "current" : t2;
  t3 === undefined ? "currentColor" : t3;
  let t4;
  if ($[6] !== size) {
    t4 = {
      width: size,
      height: size
    };
    $[6] = size;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  let t6;
  let t7;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <path d="M0 22C0 9.84974 9.84974 0 22 0V0C34.1503 0 44 9.84974 44 22V22C44 34.1503 34.1503 44 22 44V44C9.84974 44 0 34.1503 0 22V22Z" fill="#072723" />;
    t6 = <path d="M22 0.5C33.8741 0.5 43.5 10.1259 43.5 22C43.5 33.8741 33.8741 43.5 22 43.5C10.1259 43.5 0.5 33.8741 0.5 22C0.5 10.1259 10.1259 0.5 22 0.5Z" stroke="white" strokeOpacity="0.08" />;
    t7 = <path d="M36.8397 21.8616C36.8397 31.6737 30.835 34.8222 27.6712 32.0187C25.067 29.7328 24.2922 24.9023 20.3751 24.4063C15.4035 23.7809 14.973 30.4014 11.7016 30.4014C7.89216 30.4014 7.1604 24.8592 7.1604 22.0126C7.1604 19.1013 7.97825 15.1333 11.2281 15.1333C15.0161 15.1333 15.2313 20.8049 19.9662 20.503C24.6796 20.1796 24.7657 14.2707 27.822 11.7476C30.4906 9.56947 36.8397 11.9201 36.8397 21.8616Z" fill="white" fillRule="evenodd" />;
    $[8] = t5;
    $[9] = t6;
    $[10] = t7;
  } else {
    t5 = $[8];
    t6 = $[9];
    t7 = $[10];
  }
  let t8;
  if ($[11] !== className || $[12] !== rest || $[13] !== t4) {
    t8 = <svg className={className} style={t4} viewBox="0 0 44 44" xmlns="http://www.w3.org/2000/svg" {...rest}>{t5}{t6}{t7}</svg>;
    $[11] = className;
    $[12] = rest;
    $[13] = t4;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  return t8;
};